import { FormControl } from "@angular/forms";

export interface AuthorFormGroupModel {
    profilePicture: FormControl<string|null>,
    fullName: FormControl<string|null>,
    designation: FormControl<string|null>,
    linkedinUrl: FormControl<string|null>,
    description: FormControl<string|null>,
  }

  export interface ChangePasswordFormGroupModel {
    oldPassword: FormControl<string|null>,
    newPassword: FormControl<string|null>,
    confirmPassword: FormControl<string|null>,
  }

  export interface LoginFormGroupModel {
    emailAddress: FormControl<string|null>,
      password: FormControl<string|null>,
      rememberMe: FormControl<boolean|null>
  }

  export interface OptionalItemGroupModel {
    title: FormControl<string|null>,
    metaTitle: FormControl<string|null>,
    metaDescription: FormControl<string|null>
    bannerImage: FormControl<string|null>
    description: FormControl<string|null>
    bannerDescription: FormControl<string|null>
    isActive: FormControl<boolean|null>
    planType: FormControl<string|null>
  }

  export type StateAddFormGroupModel = {
    title: FormControl<string | null>,
    abbreviation: FormControl<string | null>,
    type: FormControl<string | null>,
    licenseNumber: FormControl<string | null>,
    additionalCost: FormControl<Number | null>,
    salesTax: FormControl<Number | null>,
    siteUrl: FormControl<string | null>,
    showArticle: FormControl<boolean | null>,
    metaTitle: FormControl<string | null>,
    metaDescription: FormControl<string | null>,
    serviceAgreementDetails: FormControl<string | null>,
    timezone: FormControl<string | null>
    processingFeePercentage : FormControl<number | null>
  }


  export type StateArticleFormGroupModel = {
    authorId: FormControl<string | null>,
    publishDate: FormControl<Date | null>,
    bannerImage: FormControl<Blob | File| string | null>,
    metaTitle: FormControl<string | null>,
    metaDescription: FormControl<string | null>,
    title: FormControl<string | null>,
    bannerImageAlternateText: FormControl<string | null>,
    description: FormControl<string | null>,
    stateId: FormControl<string | null>
  }

  export type CategoryFormGroupModel = {
    bannerImage: FormControl<Blob | File| string | null>,
    metaTitle: FormControl<string | null>,
    metaDescription: FormControl<string | null>,
    title: FormControl<string | null>,
    description: FormControl<string | null>,
    bannerImageAlternateText: FormControl<string | null>
  }


  export type ServiceFormGroupModel = {
    parent_service_id : FormControl<string | null>,
    title : FormControl<string | null>,
    description : FormControl<string | null>,
    coveredItemId: FormControl<string | null>
  }


  export type PartnerFormGroupModel = {
    name: FormControl<string | null>,
    apikey: FormControl<string | null>,
    sub_id: FormControl<string | null>,
    phone_number: FormControl<string | null>,
    clickid: FormControl<string | null>,
    traffic: FormControl<string | null>,
    keyword: FormControl<string | null>,
    position: FormControl<string | null>,
    partner_type: FormControl<string | null>
  }

  export type VendorFormGroupModel = {
    firstName : FormControl<string | null>,
    lastName : FormControl<string | null>,
    companyName : FormControl<string | null>,
    contactNo : FormControl<string | null>,
    emailAddress : FormControl<string | null>,
    business_email : FormControl<string | null>,
    business_contact : FormControl<string | null>,
    companyAddress : FormControl<string | null>,
    city : FormControl<string | null>,
    zipcode : FormControl<string | null>,
    state : FormControl<string | null>,
    apartmentFloor : FormControl<string | null>,
    additionalComments : FormControl<string | null>,
  }

  export type ReviewFormGroupModel = {
    firstName : FormControl<string | null>,
    lastName : FormControl<string | null>,
    contactNo : FormControl<string | null>,
    email : FormControl<string | null>,
    address : FormControl<string | null>,
    city : FormControl<string | null>,
    zipcode : FormControl<string | null>,
  }
  export type FilterFormModal = {
    searchBy : FormControl<string | null>,
    searchType : FormControl<string | null>,
  }
  export interface FilterValue  {
    title : string,
    value : string,
  }
  export interface CreateAffiliatePasswordFormGroupModel {
    newPassword: FormControl<string|null>,
    confirmPassword: FormControl<string|null>,
  }
